import { render, staticRenderFns } from "./ApiTransferWallet.vue?vue&type=template&id=1a1aad3c&"
import script from "./ApiTransferWallet.vue?vue&type=script&lang=js&"
export * from "./ApiTransferWallet.vue?vue&type=script&lang=js&"
import style0 from "./ApiTransferWallet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports